<template>
  <v-container fluid class="academic">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div><h3>Academic</h3></div>
          </v-col>
          <v-col cols="12" md="6" sm="8" class="text-right">
            <v-btn
              color="primary"
              class="academic--button"
              link
              :to="{ name: 'AcademicCard' }"
            >
              <v-icon class="mx-2"> add </v-icon>
              Add Academic
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat class="mt-4">
      <v-data-table
        id="scollStyle"
        ref="academic_list"
        :headers="headers"
        :items="academics"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        multi-sort
        class="elevation-0"
      >
        <!--eslint-disable-next-line -->
      <template v-slot:[`item.base64Attachment`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-large
                :disabled="item.base64Attachment.length === 0"
                color="indigo"
                v-bind="attrs"
                v-on="on"
                @click="download(item)"
              >
                <v-icon>download_for_offline</v-icon>
              </v-btn>
            </template>
            <span>Download Attachment</span>
          </v-tooltip>
        </template>
        <!--BEGIN actions buttons-->
        <template
          v-slot:[`item.actions`]="{ item }"
          v-if="applications.length === 0"
        >
          <v-menu open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-capitalize links"
                text
                v-bind="attrs"
                v-on="on"
                small
                ><v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :to="{
                  name: 'AcademicCard',
                  query: { edit: `${item.lineNo}` },
                }"
              >
                <v-icon color="blue darken-4">mode_edit</v-icon> Edit
              </v-list-item>
              <v-divider />
              <v-list-item @click="deleteacademic(item)">
                <v-icon color="red">delete</v-icon> Delete
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <!--END actions buttons-->
      </v-data-table>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          class="mx-2 contacts--button"
          color="error"
          text
          @click="$router.back()"
        >
          <v-icon class="mx-2"> arrow_back </v-icon>
          Back
        </v-btn>
        <v-btn
          class="mx-2 contacts--button"
          outlined
          color="primary"
          :to="{ name: 'Experience' }"
        >
          Next
          <v-icon class="mx-2"> arrow_forward </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import helpers from "@brainspore/celadon-base/utils/helpers/helper.js";
import { AuthService } from "@/packages/dashboard/modules/auth";
export default {
  name: "AcademicComponent",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      window.document.title = "KISEB::Academic Profile";
      v.$store.dispatch(
        "Application/getAllApplications",
        v.user.profile.profileID,
      );
    });
  },
  data: function () {
    return {
      sortBy: "lineNo",
      sortDesc: true,
    };
  },
  computed: {
    academics() {
      return this.$store.getters["Profile/academicsGetters"]("academics");
    },
    headers() {
      return [
        {
          text: "#S/N",
          align: "start",
          sortable: false,
          value: "lineNo",
        },
        {
          text: "Institution",
          sortable: true,
          value: "institution",
        },
        { text: "Level", sortable: true, value: "levels" },
        { text: "Certification", sortable: true, value: "certificateAwarded" },
        {
          text: "Course Title",
          sortable: true,
          value: "areaOfSpecialization",
        },
        { text: "Grade", sortable: true, value: "grade" },
        { text: "Attachment", sortable: true, value: "base64Attachment" },
        {
          text: this.applications.length !== 0 ? "" : "Actions",
          sortable: false,
          value: "actions",
        },
      ];
    },
    user() {
      return AuthService.user;
    },
    applications() {
      return this.$store.getters["Application/appGetters"](
        "applications",
      ).filter((i) => i.status === "Approved");
    },
  },
  methods: {
    deleteacademic(data) {
      delete data.base64Attachment;
      this.$store.dispatch("Profile/deleteacademics", { ...data });
    },
    download(item) {
      const a = document.createElement("a");
      a.href = `data:${helpers.detectMimeType(item.base64Attachment)};base64,${
        item.base64Attachment
      }`;
      a.download = `${item.profileID}_academics_${
        item.lineNo
      }${helpers.fileExtension(item.base64Attachment)}`;
      a.click();
    },
  },
};
</script>

<style scoped>
@import url("./styles.css");
</style>
